import type { Sort } from '@/stores/sorting';
import type { RecurringInvoiceRequest } from '@/types/recurringInvoice';
import { sortToQuery } from '@/utils/misc.ts';
import type { AxiosInstance, AxiosResponse } from 'axios';

class RecurringInvoiceService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    getPath(id?: string) {
        return id ? `/api/recurring-invoices/${id}` : '/api/recurring-invoices';
    }

    index(page: number, filter?: object, sort: null | Sort = null, perPage?: number) {
        return this.apiService.get(this.getPath(), {
            params: { page, per_page: perPage, ...filter, ...sortToQuery(sort) },
        });
    }

    show(id: string): Promise<AxiosResponse> {
        return this.apiService.get(this.getPath(id));
    }

    store(request: RecurringInvoiceRequest): Promise<AxiosResponse> {
        return this.apiService.post(this.getPath(), request);
    }

    update(id: string, request: RecurringInvoiceRequest): Promise<AxiosResponse> {
        return this.apiService.put(this.getPath(id), request);
    }

    delete(id: string): Promise<AxiosResponse> {
        return this.apiService.delete(this.getPath(id));
    }

    pause(id: string): Promise<AxiosResponse> {
        return this.apiService.post(`${this.getPath(id)}/pause`);
    }

    resume(id: string): Promise<AxiosResponse> {
        return this.apiService.post(`${this.getPath(id)}/resume`);
    }

    getInvoices(id: string, page = 1): Promise<AxiosResponse> {
        return this.apiService.get(`${this.getPath(id)}/invoices`, { params: { page } });
    }
}

export default RecurringInvoiceService;
